import { isSSR } from '@k2/core/util'
import { useOAuth } from 'vue-oidc'
import type { NavigationGuardWithThis, RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

export const oauthCallbackGuard: NavigationGuardWithThis<undefined> = async (to: RouteLocationNormalized) => {
  if (isSSR) return true

  const { oauthCallback, state } = useOAuth()
  await oauthCallback(`k2:${to.fullPath}`)

  let returnUrl: string | undefined
  try {
    returnUrl = (state.value && (JSON.parse(state.value) as { returnUrl?: string }).returnUrl) || undefined
  } catch {}

  const resumable = returnUrl && !returnUrl.startsWith('/login') && !returnUrl.startsWith('/callback')
  return ((resumable && { path: returnUrl }) || { name: 'home' }) as RouteLocationRaw
}
